import { useState } from "react";
import { useForm, SubmitHandler, Controller } from "react-hook-form";
import { useAlert } from "../../components/alert/alert";
import { SEVERITY } from "../../shared/interfaces/alert";
import { recoveryEmail, updatePasswordService } from "../../features/users/service/users-service";
import ButtonPrimary from "../../components/buttons/primary/primary";
import Loader from "../../components/loader/loader";
import LogoCompleto from '../../assets/logo.png';
import Input from "../../components/inputs/common/input";
import { useNavigate, useParams } from "react-router";
import './style.css';
import storage from "../../shared/services/storage";

export function RecoveryPassword() {
    const { control, handleSubmit } = useForm({
        defaultValues: {
            email: "",
            password: "",
            confirmPassword: ""
        }
    });
    
    const [isLoading, setIsLoading] = useState(false);
    const { email } = useParams();
    const navigate = useNavigate();
    const { showAlert } = useAlert();
    const { recovery } = useParams();
    
    const onRecoverySubmit: SubmitHandler<any> = async (data) => {
        const { email, password, confirmPassword } = data;
        setIsLoading(true);
        
        if (recovery) {
            await updatePassword(email, password, confirmPassword);
        } else {
            await askForEmail(email);
        }
    };

    const updatePassword = async (email: string, password: string, confirmPassword: string) => {
        if (password !== confirmPassword) {
            showAlert('Senhas não coincidem', SEVERITY.ERROR);
            return;
        }
        
        const user = await JSON.parse(storage.getStorage('user') || '');

        try {

            const response = await updatePasswordService({
                email: recovery? email: user.email,
                password
            });
            
            if (response) {
                showAlert('Senha trocada com sucesso', SEVERITY.SUCCESS);
                navigate('/');
            } else {
                showAlert('Erro ao trocar senha', SEVERITY.ERROR);
            }
        } catch (error) {
            showAlert('Erro ao processar solicitação', SEVERITY.ERROR);
        } finally {
            setIsLoading(false);
        }
    };

    const askForEmail = async (email: string) => {
        try {
            const response = await recoveryEmail(email);
            if (response.success) {
                showAlert('E-mail enviado, verifique sua caixa de entrada ou spam', SEVERITY.SUCCESS);
                navigate('/');
            } else {
                showAlert('Erro ao enviar e-mail', SEVERITY.ERROR);
            }
        } catch (error) {
            showAlert('Erro ao processar solicitação', SEVERITY.ERROR);
        } finally {
            setIsLoading(false);
        }
    }
    
    return (
        <div className="recovery-container">
            {isLoading && 
                <div className="recovery-loader">
                    <Loader/>
                </div>
            }
            <div className="recovery-header">
                <img src={LogoCompleto} alt="Logo causale" className="recovery-logo" />
            </div>
            
            <div className="recovery-card">
                <h1 className="recovery-title">{!recovery ? 'Digite seu e-mail' : 'Trocar senha'}</h1>
                <p className="recovery-subtitle">{!recovery ? 'Digite seu e-mail para redefinir sua senha' : 'Troque sua senha'}</p>
                
                <form className="recovery-form" onSubmit={handleSubmit(onRecoverySubmit)}>
                    {!recovery && (
                        <Controller
                                name="email"
                                control={control}
                                defaultValue={email? email: ""}
                                rules={{ 
                                required: "O e-mail é obrigatório",
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                                    message: "Endereço de e-mail inválido"
                                }
                            }}
                            render={({ field, fieldState }) => (
                                <Input 
                                    {...field}
                                    placeholder="E-mail"
                                    error={fieldState.error?.message}
                                />
                            )}
                        />
                    )}
                    {recovery && (
                        <>
                            <Controller
                                name="password"
                                control={control}
                                defaultValue=""
                                rules={{ 
                                    required: "A senha é obrigatória",
                                    minLength: {
                                        value: 6,
                                        message: "A senha deve ter pelo menos 6 caracteres"
                                    }
                                }}
                                render={({ field, fieldState }) => (
                                    <Input 
                                        {...field}
                                        placeholder="Nova senha"
                                        type="password"
                                        error={fieldState.error?.message}
                                    />
                                )}
                            />
                            <Controller
                                name="confirmPassword"
                                control={control}
                                defaultValue=""
                                rules={{ 
                                    required: "A confirmação de senha é obrigatória",
                                    minLength: {
                                        value: 6,
                                        message: "A senha deve ter pelo menos 6 caracteres"
                                    }
                                }}
                                render={({ field, fieldState }) => (
                                    <Input 
                                        {...field}
                                        placeholder="Confirmar nova senha"
                                        type="password"
                                        error={fieldState.error?.message}
                                    />
                                )}
                            />
                        </>
                    )}

                    <ButtonPrimary title="Redefinir senha"/>
                </form>
            </div>
        </div>
    );
}